import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { useInView } from '@/hooks/useInView';

export default function ResourceGrid() {
  const [ref, isInView] = useInView();

  return (
    <section ref={ref} className="relative bg-background-50 py-16 md:py-20">
      <div className={`max-w-[1400px] mx-auto px-6 md:px-10 transition-all duration-700 ease-out ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10">
          <div>
            <p className="font-label text-sm font-medium text-foreground-400 uppercase tracking-wider mb-2">
              Spreadsheet
            </p>
            <h2 className="font-heading text-3xl md:text-4xl italic font-semibold text-foreground-950">
              Resources &amp; Blog
            </h2>
          </div>
          <div className="flex items-center gap-4">
            <p className="text-sm text-foreground-500 leading-relaxed max-w-md hidden lg:block">
              Dive into our expert-written <strong>mulebuy spreadsheet</strong> guides, comparisons, and tips. New articles added weekly to help you master the platform.
            </p>
            <span className="hidden md:inline-flex items-center px-4 py-1.5 rounded-full bg-foreground-900 text-background-50 text-xs font-semibold whitespace-nowrap">
              {articles.length} Articles
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/${article.slug}`}
              className="group bg-background-50 rounded-2xl border border-background-200/50 overflow-hidden hover:border-accent-300 transition-all cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-md bg-accent-100 text-accent-800 text-xs font-semibold whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-950 leading-snug mb-2 group-hover:text-accent-700 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-background-100 group-hover:bg-accent-100 transition-colors">
                    <i className="ri-arrow-right-line text-xs text-foreground-500 group-hover:text-accent-600 transition-colors"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}